import { isFuture, isMatch, isBefore, parse } from "date-fns"

export const isDateValid = (stringDate: string): boolean => {
  return stringDate.trim().length === 10 && isMatch(stringDate, 'MM/dd/yyyy')
}

export const isMonthYearValid = (stringDate: string): boolean => {
  return isMatch(stringDate, 'MM/yyyy')
}

export const isFutureDate = (stringDate: string, monthYear: boolean = false): boolean => {
  return monthYear === true ? isFuture(parse(stringDate, 'MM/yyyy', new Date())) : isFuture(new Date(stringDate));
}

export const isBeforeLongAgo = (stringDate: string, monthYear: boolean = false): boolean => {
  return monthYear === true ? isBefore(parse(stringDate, 'MM/yyyy', new Date()), new Date(1800, 0, 1)) : isBefore(new Date(stringDate), new Date(1800, 0, 1))
}